<router-outlet></router-outlet>
<app-footer ></app-footer>

<div *ngIf="loadingService.loading$ | async" class="global-loading-overlay">
    <div class="premium-loader">
        <div class="core"></div>
    </div>
</div>